import React, { useEffect, Children } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { Header } from './components/Header';
import { VideoPlayer } from './components/VideoPlayer';
import { HeroHighlight, Highlight } from './components/ui/HeroHighlight';
import { BookCallButton } from './components/ui/BookCallButton';
import { CultureQuestionsPage } from './pages/CultureQuestionsPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { DnsPage } from './pages/DnsPage';
import { IndeedPage } from './pages/IndeedPage';
import { CompletionPage } from './pages/CompletionPage';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100,
        duration: 0.4
      }
    }
  };
  return <div className="w-full h-screen overflow-hidden" data-id="element-0">
      <HeroHighlight data-id="element-1">
        <div className="h-screen flex flex-col" data-id="element-2">
          <Header data-id="element-3" />
          <motion.main className="flex-1 flex flex-col justify-center max-w-5xl mx-auto px-4 w-full" initial="hidden" animate="visible" variants={containerVariants} data-id="element-4">
            <motion.div id="headline" variants={itemVariants} data-id="element-5">
              <h1 className="text-center text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 sm:mb-3 max-w-3xl mx-auto leading-[1.3] text-white" data-id="element-6">
                Welcome to HIRE, please complete all steps for us to get the
                necessary information to build your recruiting engine!
              </h1>
              <div className="relative max-w-3xl mx-auto w-full" data-id="element-7">
                <VideoPlayer mediaId="evk6hg2a67" data-id="element-8" />
                <motion.button onClick={() => navigate('/culture-questions')} className="hidden md:flex flex-col items-center gap-1 px-3 py-4 rounded-xl bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors cursor-pointer absolute -right-16" style={{
                top: '50%',
                y: '-50%'
              }} whileHover={{
                scale: 1.05,
                x: 4
              }} whileTap={{
                scale: 0.95
              }} data-id="element-9">
                  <ChevronRightIcon className="w-6 h-6" data-id="element-10" />
                  <span className="text-xs font-semibold whitespace-nowrap" data-id="element-11">
                    Get Started
                  </span>
                </motion.button>
              </div>
              <motion.button onClick={() => navigate('/culture-questions')} className="md:hidden flex items-center justify-center gap-2 mx-auto mt-3 py-2.5 px-6 rounded-xl bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors cursor-pointer" whileTap={{
              scale: 0.95
            }} data-id="element-12">
                <span className="text-sm font-semibold" data-id="element-13">Get Started</span>
                <ChevronRightIcon className="w-5 h-5" data-id="element-14" />
              </motion.button>
            </motion.div>

            <motion.div className="mt-8 mb-12" variants={itemVariants} data-id="element-15">
              <p className="text-center text-lg sm:text-xl font-medium text-white/80 italic" data-id="element-16">
                Message from one of our Founders - Peter Swenson
              </p>
            </motion.div>
          </motion.main>
        </div>
      </HeroHighlight>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-17">
      <Routes data-id="element-18">
        <Route path="/" element={<HomePage data-id="element-20" />} data-id="element-19" />
        <Route path="/culture-questions" element={<CultureQuestionsPage data-id="element-22" />} data-id="element-21" />
        <Route path="/onboarding" element={<OnboardingPage data-id="element-24" />} data-id="element-23" />
        <Route path="/dns" element={<DnsPage data-id="element-26" />} data-id="element-25" />
        <Route path="/indeed" element={<IndeedPage data-id="element-28" />} data-id="element-27" />
        <Route path="/completion" element={<CompletionPage data-id="element-30" />} data-id="element-29" />
      </Routes>
    </BrowserRouter>;
}